import { Images } from 'utils/images';
import moment from 'moment';
import { DocumentSettings } from './documentSettings';
import { TextToolTip } from '../toolTip';
import { CARRIER_DOCK_STATUSES, CARRIER_DOCKS } from '../../pages/carriers/constants';
import { ApproveOrDeny } from './approveOrDeny';
import { MinLoader } from '../loader';
import { AntSwitch, Colors } from 'utils';

export const renderFileTypeSvg = (file, uploadDocError) => {
  if (file) {
    if (uploadDocError?.errorForSize) {
      return Images.UploadFileError;
    } else if (file?.type?.includes('png') || file?.format?.includes('jpg')) {
      return Images.PNgSvg;
    } else if (file?.type?.includes('jpeg') || file?.type?.includes('jpg') || file?.format?.includes('jpeg') || file?.format?.includes('jpg')) {
      return Images.JPEgSVG;
    } else if (file?.type === 'application/pdf' || file?.format?.includes('application/pdf')) {
      return Images.PDfSvg;
    } else {
      return Images.FileTypeSvg;
    }
  }
};


export const documentsHeader = ({ documentsTypes, dontShowUploadedByt, allowSwitchStatus }) => {
  return [
    { name: '', title: 'Document Name', custom: false, width: '400px' },
    !dontShowUploadedByt && { name: '', title: 'Uploaded by', custom: false, width: '210px' },
    documentsTypes && { name: '', title: 'Type', custom: false, width: '145px' },
    { name: '', title: 'Note', custom: false },
    { name: '', title: 'Status', custom: false, width: '76px' },
    { name: '', title: '', custom: false, notSearch: true, width: '50px' },
  ];
};

const fileType = (type) => {
  switch (type) {
    case 'png':
      return Images.PNgSvg;
    case 'jpg':
      return Images.JPEgSVG;
    case 'jpeg':
      return Images.JPEgSVG;
    case 'pdf':
      return Images.PDfSvg;
    default:
      return Images.FileTypeSvg;
  }
};


export const loadCustomerInfoBody = (
  {
    documentsTypes,
    changeStatus,
    changeStatusAction,
    allowSwitchStatus = true,
    handleDeleteDocument,
    deleteDocAction,
    permissionForDelete,
    dontShowUploadedByt,
    selectedItem,
    dontAllowAddDocument,
    dontChangeType,
    loadingStatus,
  },
) => {

  const statusDisabled = (item) => {
    return  item.status === CARRIER_DOCK_STATUSES?.PENDING ||
      (item?.type === CARRIER_DOCKS?.PROOF_OF_INSURANCE && item?.status === CARRIER_DOCK_STATUSES?.PENDING) ||
      !allowSwitchStatus
  };

  return [
    {
      rowText: (item) => (
        <div className='align-center' style={{ gap: '16px' }}>
          <div className='doc-type-img-block'>
            <img src={fileType(item?.file?.format)} alt='file type' />
          </div>

          <div className='document-name-size-wrapper'>
            <TextToolTip
              content={item?.file?.originalName || item?.file?.name}
              text={item?.file?.originalName || item?.file?.name}
              classNameText='doc-type-name'
              onClick={() => {
                if (item?.file?.url) {
                  window.open(item?.file?.url, '_blank');
                }
              }}
            />
          </div>
        </div>
      ),
    },
    !dontShowUploadedByt && {
      rowText: (item) => {
        const date = item?.createdDate || item?.createdAt;

        return (
          <div className='document-name-size-wrapper'>
            <TextToolTip
              content={item?.creator || '-'}
              text={item?.creator || '-'}
              classNameText='doc-type-main-text-styles'
            />
            {date &&
              <TextToolTip
                content={date ? `${moment.utc(date).format('MM/DD/YYYY')} ${moment(date).format('LT')}` : '-'}
                text={date ? `${moment.utc(date).format('MM/DD/YYYY')} ${moment(date).format('LT')}` : '-'}
                classNameText='doc-type-main-text-styles'
                textStyles={{ color: '#9C9EA9' }}
              />
            }
          </div>
        );
      },
    },

    documentsTypes && {
      rowText: (item) => (
        <div>
          <TextToolTip
            content={documentsTypes.find((doc) => doc?.id === item?.type)?.name}
            text={documentsTypes.find((doc) => doc?.id === item?.type)?.name}
            classNameText='doc-type-main-text-styles'
          />
        </div>
      ),
    },

    {
      rowText: (item) => (
        <div className='flex'>
          <TextToolTip
            content={item?.notes}
            text={item?.notes}
            classNameText='doc-type-main-text-styles'
          />
        </div>
      ),
    },
    {
      rowText: (item) => (
        <div className='flex' style={{ justifyContent: 'center', alignItems: 'center' }}>
          {(!!loadingStatus && selectedItem === item?.id) ?
            <MinLoader
              margin={'0'}
              position={'relative'}
              color={Colors.ThemeBlue}
            />
            :
            <div style={{ opacity: (statusDisabled(item) && item.status === 'ACTIVE') ? '.5' : 1 }}>
              <AntSwitch
                disabled={statusDisabled(item)}
                onClick={() => changeStatus(item)}
                checked={item.status === 'ACTIVE'}
              />
            </div>
          }
        </div>
      ),
    },
    {
      rowText: (item) => (
        <div className='flex' style={{ justifyContent: 'flex-end' }}>
          {(item?.type === CARRIER_DOCKS?.PROOF_OF_INSURANCE && item?.status === CARRIER_DOCK_STATUSES?.PENDING) ?
            <ApproveOrDeny
              item={item}
              selectedItem={selectedItem}
              changeStatusAction={changeStatusAction}
              handleChangeStatus={changeStatus}
            />
            :
            <DocumentSettings
              document={item}
              docTypes={documentsTypes}
              handleChangeStatus={changeStatus}
              changeStatusAction={changeStatusAction}
              handleDeleteDocument={handleDeleteDocument}
              deleteDocAction={deleteDocAction}
              permissionForDelete={permissionForDelete}
              dontAllowAddDocument={dontAllowAddDocument}
              dontChangeType={dontChangeType}
            />
          }
        </div>
      ),
    },
  ];
};